import React from 'react';
import { apiHolder as api } from 'api';
import { useActions, useAppSelector, MailTemplateActions, TempContactActions } from '@web-common/state/createStore';
import LxEditor from '@web-common/components/UI/LxEditor/LxEditor';
import toast from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
export const TemplateEditor = () => {
    const { doChangeMailContent, doConferenceSettting, doClosePreviewModal } = useActions(MailTemplateActions);
    const content = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailTemplateReducer.mailTemplateContent.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content; });
    const FileApi = api.api.getFileApi();
    const { doFocusSelector } = useActions(TempContactActions);
    const imagesUploadHandler = (blobInfo, succFun, failFun) => {
        let file = blobInfo.blob();
        if (Object.prototype.toString.call(blobInfo.blob()) !== '[object File]') {
            file = new File[blobInfo.blob()]();
        }
        FileApi.uploadFile({
            fileName: file.name,
            file,
            fileSourceType: file.type,
            fileSize: file.size,
        })
            .then(({ data }) => {
            if (data.code !== 200) {
                if (data.message === '系统检测为风险文件，上传失败') {
                    toast.error({ content: '系统检测为风险文件，上传失败' });
                }
                return Promise.reject(data);
            }
            succFun({ url: data.data.url, originUrl: data.data.url });
        })
            .catch(() => {
            failFun();
        });
    };
    const init = {
        setup: ed => {
            ed.on('blur', () => {
                doChangeMailContent(ed.getContent());
            });
        },
        min_height: 200,
        images_upload_handler: imagesUploadHandler,
    };
    return (React.createElement(LxEditor, { value: content, uniqueClass: "template-editor", init: init, onEditorChange: v => doChangeMailContent(v), onClick: () => {
            doFocusSelector(getIn18Text('ZHENGWEN'));
            doConferenceSettting(false);
            doClosePreviewModal(true);
        } }));
};
